module.exports = __webpack_public_path__ + "static/media/25logo.4db63e49.jpg";